import { lazy } from "react";
import Loadable from "app/components/Loadable";

const ReportViewerPopup = Loadable(
    lazy(() => import("../components/ReportViewerPopup"))
);

const directDepositReportsRoute = [
    {
        path: "/directdepositreports/report-viewer",
        element: <ReportViewerPopup />
    }
];

export default directDepositReportsRoute;